import {TextField} from "@mui/material";
import styled from "styled-components";
import {media} from "../../../theme";

export const StyledCard = styled.div`
    width: 100%;
    max-width: 450px;
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: 40px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    ${media.sm} {
        padding: 32px;
        gap: 20px;
    }

    ${media.md} {
        padding: 40px;
        gap: 24px;
    }
`;

export const Header = styled.h1`
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: ${({theme}) => theme.palette.text.primary};
    letter-spacing: -0.02em;
    text-align: center;

    ${media.sm} {
        font-size: 22px;
        line-height: 30px;
    }

    ${media.md} {
        font-size: 24px;
        line-height: 33px;
    }
`;

export const Subtext = styled.p`
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: ${({theme}) => theme.palette.text.secondary};
    letter-spacing: -0.02em;
    text-align: center;
    margin-top: -8px;

    ${media.sm} {
        font-size: 14px;
        line-height: 20px;
        margin-top: -10px;
    }
`;

export const StyledForm = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.sm} {
        gap: 20px;
    }

    ${media.md} {
        gap: 24px;
    }
`;

export const StyledTextField = styled(TextField)`
    && {
        .MuiOutlinedInput-root {
            border-radius: 16px;
            background-color: ${({theme}) => theme.palette.background.input};

            & fieldset {
                border-color: ${({theme}) => theme.palette.dividers.default};
            }

            &:hover fieldset {
                border-color: ${({theme}) => theme.palette.dividers.focus};
            }

            &.Mui-focused fieldset {
                border-color: ${({theme}) => theme.palette.dividers.focus};
            }
        }

        .MuiInputLabel-root {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: ${({theme}) => theme.palette.text.primary};

            &.Mui-focused {
                color: ${({theme}) => theme.palette.text.primary};
            }
        }

        input {
            font-size: 14px;
            line-height: 20px;
            color: ${({theme}) => theme.palette.text.primary};
        }

        input:-webkit-autofill {
            box-shadow: 0 0 0 1000px #ffffff inset;
            -webkit-text-fill-color: ${({theme}) => theme.palette.text.primary};
        }
    }
`;